import { useMediaQuery } from '@mantine/hooks'

export const useResponsiveHooks = () => {
	const isMobile = useMediaQuery(`(max-width: 480px)`)
	const isTablet = useMediaQuery(`(max-width: 668px)`)
	const isLaptop = useMediaQuery(`(max-width: 1024px)`)
	const isLaptopMid = useMediaQuery(`(max-width: 1200px)`)
	const isLargeScreen = useMediaQuery(`(max-width: 1440px)`)
	const isExtraLargeScreen = useMediaQuery(`(max-width: 1920px)`)

	return {
		isMobile,
		isTablet,
		isLaptop,
		isLargeScreen,
		isLaptopMid,
		isExtraLargeScreen,
	}
}
    